// extracted by mini-css-extract-plugin
export default {"tabButton":"TabsContainer_tabButton__c6P4i","tabButtonSelected":"TabsContainer_tabButtonSelected__8hI33","tabsContainer":"TabsContainer_tabsContainer__txO71"};